/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {InjectionToken} from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window', {
  providedIn: 'root',
  factory: () => window,
});
